import React from 'react';
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  TextField,
} from '@mui/material';
import { useTranslation } from '../../../app/LanguageContext';
import { subtleSurfaceBg } from '../../../theme/surfaceSx';

const ListToolbar = ({
  filterValue,
  filterOptions = [],
  onFilterChange,
  filterLabelKey = 'products.item_type',
  searchValue = '',
  onSearchChange,
  searchLabelKey = 'common.search',
  searchHelperTextKey,
}) => {
  const { translate } = useTranslation();
  const hasFilter = filterOptions.length > 0 && onFilterChange;
  const hasSearch = typeof onSearchChange === 'function';

  if (!hasFilter && !hasSearch) return null;

  return (
    <Box
      component="header"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1.5,
        py: 2,
        px: 3,
        mb: 2,
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: subtleSurfaceBg,
      }}
    >
      {hasFilter && (
        <>
          <Typography
            variant="overline"
            sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: 1 }}
          >
            {translate(filterLabelKey)}
          </Typography>
          <ToggleButtonGroup
            value={filterValue}
            exclusive
            onChange={(_, v) => v != null && onFilterChange(v)}
            size="small"
            sx={{
              '& .MuiToggleButtonGroup-grouped': {
                border: 1,
                borderColor: 'divider',
                px: 2,
                py: 0.75,
                '&.Mui-selected': {
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  '&:hover': { bgcolor: 'primary.dark' },
                },
              },
            }}
          >
            {filterOptions.map((opt) => (
              <ToggleButton key={opt.value} value={opt.value} aria-label={translate(opt.labelKey)}>
                {translate(opt.labelKey)}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </>
      )}
      {hasSearch && (
        <TextField
          size="small"
          label={translate(searchLabelKey)}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          helperText={searchHelperTextKey ? translate(searchHelperTextKey) : undefined}
          sx={{
            flex: 1,
            minWidth: 200,
            ml: hasFilter ? { xs: 0, md: 'auto' } : 0,
            width: hasFilter ? { xs: '100%', md: 'auto' } : '100%',
          }}
        />
      )}
    </Box>
  );
};

export default ListToolbar;
